<template functional>
  <div class="withdraw-vertify-state-label-wrapper">
    <template v-if="props.status === $options.status().WAITING">
      <div class="state-label" style="background-color:#00bd83;">
        <i class="el-icon-circle el-icon-time"></i>
      </div>
      <span style="color:#00bd83;">待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().CERTIFIED">
      <div class="state-label" style="background-color:#005bff">
        <i class="el-icon-circle el-icon-circle-check"></i>
      </div>
      <span style="color:#005bff">审核通过</span>
    </template>
    <template v-else-if="props.status === $options.status().INVALID">
      <div class="state-label" style="background-color:#FF5753">
        <i class="el-icon-circle el-icon-circle-close"></i>
      </div>
      <span style="color:#FF5753">审核失败</span>
    </template>
    <template v-else>
      <span style="color:#dadde0">- -</span>
    </template>
  </div>
</template>

<script>
import { VERTIFY_STATUS } from '../_eum';
export default {
  name: 'withdrawVertifyStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return VERTIFY_STATUS;
  }
};
</script>

<style lang="scss">
.withdraw-vertify-state-label-wrapper {
  display: flex;
  align-items: center;
  .state-label {
    height: 20px;
    width: 20px;
    padding: 2px;
    border-radius: 50%;
    line-height: 16px;
    margin-right: 9px;
    i {
      font-size: 16px;
      line-height: 16px;
      color: white;
    }
  }
}
</style>
